import { getDataWithToken } from "../api/api";
import { GETADS, GETCONFIG, GETUSER } from "../helpers/Constant";

export const setSession = (user) => {
    if(user){
        if(user.token){
            localStorage.setItem('predict_token', user.token.replaceAll('"', ''));
        }
        if(user.userId && user.email){
            localStorage.setItem('user_id', user.userId);
            localStorage.setItem('user_email', user.email);
        }else{
            localStorage.setItem('user_id', user._id);
        }
        localStorage.setItem('user_lng', user.language);
        localStorage.setItem('user_info', JSON.stringify(user));
        var login = getIsFirstLogin();
        if(user.lastDeviceInfo == null && (login == null || !login)){
            setIsFirstLogin(true);
        }
    }else{
        localStorage.removeItem('predict_token');
        localStorage.removeItem('user_info');
        localStorage.removeItem('user_id');
        localStorage.removeItem('user_email');
        localStorage.removeItem('user_lng');
        localStorage.removeItem('match_id');
    }
};

export const setMatchId = (match) => {
    return localStorage.setItem('match_id',match);
};


export const getMatchId = () => {
    return localStorage.getItem('match_id');
};

export const getLanguage = () => {
    return localStorage.getItem('user_lng');
};

export const getAccessToken = () => {
    return localStorage.getItem('predict_token');
};

export const getUserId = () => {
    return localStorage.getItem('user_id');
};

export const setIsFirstLogin = (val) => {
    return localStorage.setItem('isFirstLogin', val);
};

export const getIsFirstLogin = () => {
    return localStorage.getItem('isFirstLogin');
};

export const getUserInfo = () => {
    const userData = localStorage.getItem('user_info');
    if(userData){
        return JSON.parse(userData);
    }else{
        return null;
    }
};

export const setAppConfigs = (data) => {
    return localStorage.setItem('app_configs',JSON.stringify(data));
};

export const getAppConfigs = (data) => {
    const appData = localStorage.getItem('app_configs');
    if(appData){
        return JSON.parse(appData);
    }else{
        return null;
    }
};

export const checkAuth = async () => {
    var value = getAccessToken();
    if(!value){
        setSession(null);
        return null;
    }else{
        const user = await getDataWithToken(GETUSER);
        if (user.status !== 200) {
            setSession(null);
            return null;
        } else {
            setSession(user.data);
            return user.data;
        }
    }
};

export const getConfigs = async () => {
    const config = await getDataWithToken(GETCONFIG);
    if (config.status !== 200) {
        return null;
    } else {
        setAppConfigs(config.data);
        return config.data;
    }
};

export const getAds = async () => {
    const ads = await getDataWithToken(GETADS);
    if (ads.status !== 200) {
        return [];
    } else {
        return ads.data;
    }
};